/*
 * GT wholesale catalog - pack/box quantity selector.
 * Tabs set the active pack/box amount; +/- step by that amount; the chosen
 * quantity is written to the hidden name="quantity" input so Dawn's
 * product-form Ajax add-to-cart submits it. Event-delegated so it survives
 * product-grid re-renders. No hardcoded strings (labels come from Liquid/locales).
 */
(function () {
  function num(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('[data-gt-qty]');
    if (!wrap) return;
    var tab = e.target.closest('[data-gt-amount]');
    var step = e.target.closest('[data-gt-step]');
    if (!tab && !step) return;

    var valueEl = wrap.querySelector('[data-gt-value]');
    var card = wrap.closest('.gt-card');
    var input = card ? card.querySelector('[data-gt-qty-input]') : null;
    var activeTab = wrap.querySelector('[data-gt-amount].is-active') || wrap.querySelector('[data-gt-amount]');
    var amount = num(activeTab && activeTab.getAttribute('data-gt-amount'), 1);
    var qty = num(valueEl && valueEl.textContent, amount);

    if (tab) {
      var tabs = wrap.querySelectorAll('[data-gt-amount]');
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('is-active');
        tabs[i].setAttribute('aria-pressed', 'false');
      }
      tab.classList.add('is-active');
      tab.setAttribute('aria-pressed', 'true');
      amount = num(tab.getAttribute('data-gt-amount'), 1);
      qty = amount;
    } else if (step) {
      var dir = num(step.getAttribute('data-gt-step'), 0);
      qty = Math.max(amount, qty + dir * amount);
    }

    if (valueEl) valueEl.textContent = qty;
    if (input) input.value = qty;
    // Persist the chosen selling unit for the cart (hidden _gt_step line-item property).
    var stepInput = card ? card.querySelector('[data-gt-step-input]') : null;
    if (stepInput) stepInput.value = amount;
  });
})();
